import { render, staticRenderFns } from "./InformationImprovementTotalPay.vue?vue&type=template&id=245ee5d6&scoped=true"
import script from "./InformationImprovementTotalPay.vue?vue&type=script&lang=js"
export * from "./InformationImprovementTotalPay.vue?vue&type=script&lang=js"
import style0 from "./InformationImprovementTotalPay.vue?vue&type=style&index=0&id=245ee5d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ee5d6",
  null
  
)

export default component.exports